import { Alert as MuiAlert, styled } from '@mui/material';
export const AlertStyled = styled(MuiAlert, { shouldForwardProp: (prop) => prop !== 'size' })(({ theme, size }) => ({
    ...(size === 'small' && {
        padding: theme.spacing(3),
        fontSize: theme.typography.caption.fontSize,
    }),
}));
